import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjCommunicate"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.875 3.63276C1.875 2.83457 2.52207 2.1875 3.32026 2.1875H16.6797C17.4779 2.1875 18.125 2.83457 18.125 3.63276V12.8193C18.125 13.6175 17.4779 14.2646 16.6797 14.2646H8.7283L5.68166 17.3949C5.38011 17.7047 4.85467 17.4912 4.85467 17.0589V14.2646H3.32026C2.52207 14.2646 1.875 13.6175 1.875 12.8193V3.63276ZM5.12507 5.96293C5.12507 5.69687 5.34076 5.48118 5.60682 5.48118H14.3933C14.6594 5.48118 14.8751 5.69687 14.8751 5.96293V6.6463C14.8751 6.91237 14.6594 7.12806 14.3933 7.12806H5.60682C5.34076 7.12806 5.12507 6.91237 5.12507 6.6463V5.96293ZM5.60682 8.77515C5.34076 8.77515 5.12507 8.99084 5.12507 9.2569V9.94027C5.12507 10.2063 5.34076 10.422 5.60682 10.422H11.1433C11.4094 10.422 11.6251 10.2063 11.6251 9.94027V9.2569C11.6251 8.99084 11.4094 8.77515 11.1433 8.77515H5.60682Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var SJ_communicate = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_communicate as default };
